//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue' // 面包屑
import navigationComp from '~/components/help/navigation.vue' // 左侧导航
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'navigation-comp': navigationComp
  },
  asyncData ({ route }) {
    const arr = [
      'lang-help-instructions-for-using-vps.html',
      'lang-help-vps-product-classification.html',
      'lang-help-buy-vps-server-process.html',
      'lang-help-helpWin.html',
      'lang-help-helpMac.html',
      'lang-help-mt4-account-binding-process.html',
      'lang-help-mt5-account-binding-process.html',
      'lang-help-ctrader-account-binding-process.html'
    ]
    const activeIndex = arr.findIndex(item => item == route.name)
    return {
      activeIndex
    }
  },
  data () {
    return {
      content: {
        'zh-cn': `
        <div class="title-box">Windows如何连接VPS？</div>
                  <p class="bold">
                      什么是VPS？
                  </p>
                  <p>
                      VPS（Virtual Private Server，虚拟专用服务器），您可以通过远程桌面连接访问WikiFX的VPS。
                  </p>
                  <p>
                      <strong>第一步</strong>
                  </p>
                  <p>
                      打开WikiFX APP，进入【我的】-【我的VPS】获取您的主机IP、用户名和密码。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      <strong>第二步</strong>
                  </p>
                  <p>
                      打开Windows电脑，按住【Win+R】键，启动命令行工具，输入【mstsc】，进行远程桌面连接。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      进入远程桌面连接，在计算机栏目中输入VPS IP（主机IP），单击【连接】按钮
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      连接成功后，输入登录账户名和登录密码后，单击【确定】按钮
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      此时会出现一个弹窗，单击【是】，继续连接
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      <strong>第三步</strong>
                  </p>
                  <p>
                      连接成功，进入VPS。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        zh: `
        <div class="title-box">Windows如何連接VPS？</div>
                  <p class="bold">
                      什麼是VPS？
                  </p>
                  <p>
                      VPS（Virtual Private Server，虛擬專用伺服器），您可以透過遠端桌面連線存取WikiFX的VPS。
                  </p>
                  <p class="bold">
                      第一步
                  </p>
                  <p>
                      開啟WikiFX APP，進入【我的】-【我的VPS】取得您的主機IP、使用者名稱和密碼。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p class="bold">
                      第二步
                  </p>
                  <p>
                      開啟Windows電腦，按住【Win+R】鍵，啟動命令列工具，輸入【mstsc】，進行遠端桌面連線。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      進入遠端桌面連接，在電腦欄位中輸入VPS IP（主機IP），點選【連接】按鈕
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      連線成功後，輸入登入帳號名稱和登入密碼後，點選【確定】按鈕
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      此時會出現一個彈跳窗，點選【是】，繼續連接
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p class="bold">
                      第三步
                  </p>
                  <p>
                      連線成功，進入VPS。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        en: `
        <div class="title-box">How to connect to VPS in Windows?</div>
                  <p class="bold">
                      What is a VPS?
                  </p>
                  <p>
                      VPS (Virtual Private Server), you can access WikiFX&#39;s VPS through a remote desktop connection.
                  </p>
                  <p class="bold">
                      first step
                  </p>
                  <p>
                      Open WikiFX APP, go to [My]-[My VPS] to get your host IP, username and password.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p class="bold">
                      Step 2
                  </p>
                  <p>
                      Open the Windows computer, press and hold the [Win+R] keys, start the command line tool, and enter [mstsc] to connect to the remote desktop.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Enter the remote desktop connection, enter the VPS IP (host IP) in the computer column, and click the [Connect] button
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      After the connection is successful, enter the login account name and password, and click the [OK] button
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      A pop-up window will appear, click [Yes] to continue connecting.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p class="bold">
                      third step
                  </p>
                  <p>
                      The connection is successful and you enter the VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        ru: `
        <div class="title-box">Как подключиться к VPS в Windows?</div>
                  <p class="bold">
                      Что такое VPS?
                  </p>
                  <p>
                      VPS (виртуальный частный сервер), вы можете получить доступ к VPS WikiFX через подключение к удаленному рабочему столу.
                  </p>
                  <p>
                      первый шаг
                  </p>
                  <p>
                      Откройте приложение WikiFX, перейдите в раздел [Мой]-[Мой VPS], чтобы получить IP-адрес вашего хоста, имя пользователя и пароль.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      Шаг 2
                  </p>
                  <p>
                      Откройте компьютер с Windows, нажмите и удерживайте клавиши [Win+R], запустите инструмент командной строки и введите [mstsc] для подключения к удаленному рабочему столу.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Введите подключение к удаленному рабочему столу, введите IP-адрес VPS (IP-адрес хоста) в столбце компьютера и нажмите кнопку [Подключиться].
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      После успешного подключения введите имя и пароль учетной записи и нажмите кнопку [ОК].
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      Появится всплывающее окно, нажмите [Да], чтобы продолжить подключение.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      третий шаг
                  </p>
                  <p>
                      Соединение прошло успешно и вы вошли на VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        ja: `
        <div class="title-box">Windows で VPS に接続するにはどうすればよいですか?</div>
                  <p class="bold">
                      VPSとは何ですか?
                  </p>
                  <p>
                      VPS (仮想プライベート サーバー) では、リモート デスクトップ接続を通じて WikiFX の VPS にアクセスできます。
                  </p>
                  <p>
                      最初の一歩
                  </p>
                  <p>
                      WikiFX アプリを開き、[My]-[My VPS] に移動してホスト IP、ユーザー名、パスワードを取得します。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      ステップ2
                  </p>
                  <p>
                      Windows コンピューターを開き、[Win+R] キーを押したままコマンド ライン ツールを起動し、「mstsc」と入力してリモート デスクトップに接続します。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      リモートデスクトップ接続に入り、コンピュータ欄にVPS IP（ホストIP）を入力し、[接続]ボタンをクリックします
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      接続に成功したら、ログインアカウント名とパスワードを入力し、[OK]ボタンをクリックします。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      ポップアップウィンドウが表示されますので、[はい]をクリックして接続を続行します。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      第三段階
                  </p>
                  <p>
                      接続が成功し、VPS に入ります。
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        th: `
        <div class="title-box">จะเชื่อมต่อกับ VPS ใน Windows ได้อย่างไร?</div>
                  <p class="bold">
                      VPS คืออะไร?
                  </p>
                  <p>
                      VPS (เซิร์ฟเวอร์ส่วนตัวเสมือน) คุณสามารถเข้าถึง VPS ของ WikiFX ผ่านการเชื่อมต่อเดสก์ท็อประยะไกล
                  </p>
                  <p>
                      ขั้นแรก
                  </p>
                  <p>
                      เปิดแอป WikiFX ไปที่ [ของฉัน]-[VPS ของฉัน] เพื่อรับ IP โฮสต์ ชื่อผู้ใช้ และรหัสผ่านของคุณ
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      ขั้นตอนที่ 2
                  </p>
                  <p>
                      เปิดคอมพิวเตอร์ Windows กดปุ่ม [Win+R] ค้างไว้ เริ่มเครื่องมือบรรทัดคำสั่ง และป้อน [mstsc] เพื่อเชื่อมต่อกับเดสก์ท็อประยะไกล
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      ป้อนการเชื่อมต่อเดสก์ท็อประยะไกล ป้อน VPS IP (host IP) ในคอลัมน์คอมพิวเตอร์ และคลิกปุ่ม [เชื่อมต่อ]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      หลังจากการเชื่อมต่อสำเร็จ ให้ป้อนชื่อบัญชีล็อกอินและรหัสผ่าน แล้วคลิกปุ่ม [ตกลง]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      หน้าต่างป๊อปอัปจะปรากฏขึ้น คลิก [ใช่] เพื่อเชื่อมต่อต่อ
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      ขั้นตอนที่สาม
                  </p>
                  <p>
                      การเชื่อมต่อสำเร็จและคุณเข้าสู่ VPS
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        vi: `
        <div class="title-box">Làm cách nào để kết nối với VPS trong Windows?</div>
                  <p class="bold">
                      VPS là gì?
                  </p>
                  <p>
                      VPS (Máy chủ riêng ảo), bạn có thể truy cập VPS của WikiFX thông qua kết nối máy tính từ xa.
                  </p>
                  <p>
                      bước đầu tiên
                  </p>
                  <p>
                      Mở ứng dụng WikiFX, đi tới [My]-[My VPS] để lấy IP máy chủ, tên người dùng và mật khẩu của bạn.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      Bước 2
                  </p>
                  <p>
                      Mở máy tính Windows, nhấn và giữ phím [Win+R], khởi động công cụ dòng lệnh và nhập [mstsc] để kết nối với máy tính từ xa.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Nhập kết nối máy tính từ xa, nhập IP VPS (IP máy chủ) vào cột máy tính và nhấp vào nút [Kết nối]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      Sau khi kết nối thành công, nhập tên tài khoản và mật khẩu đăng nhập rồi nhấp vào nút [OK]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      Một cửa sổ bật lên sẽ xuất hiện, nhấp vào [Có] để tiếp tục kết nối.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      bước thứ ba
                  </p>
                  <p>
                      Kết nối thành công và bạn vào VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        id: `
        <div class="title-box">Bagaimana cara terhubung ke VPS di Windows?</div>
                  <p class="bold">
                      Apa itu VPS?
                  </p>
                  <p>
                      VPS (Virtual Private Server), Anda dapat mengakses VPS WikiFX melalui koneksi desktop jarak jauh.
                  </p>
                  <p>
                      Langkah pertama
                  </p>
                  <p>
                      Buka APLIKASI WikiFX, buka [Saya]-[VPS Saya] untuk mendapatkan IP host, nama pengguna, dan kata sandi Anda.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      Langkah 2
                  </p>
                  <p>
                      Buka komputer Windows, tekan dan tahan tombol [Win+R], mulai alat baris perintah, dan masukkan [mstsc] untuk menyambung ke desktop jarak jauh.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Masukkan koneksi remote desktop, masukkan IP VPS (IP host) di kolom komputer, dan klik tombol [Connect].
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      Setelah koneksi berhasil, masukkan nama akun login dan kata sandi, lalu klik tombol [OK].
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      Jendela pop-up akan muncul, klik [Ya] untuk melanjutkan koneksi.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      langkah ketiga
                  </p>
                  <p>
                      Koneksi berhasil dan Anda masuk ke VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        es: `
        <div class="title-box">¿Cómo conectarse a VPS en Windows?</div>
                  <p class="bold">
                      ¿Qué es un VPS?
                  </p>
                  <p>
                      VPS (Servidor Privado Virtual), puede acceder al VPS de WikiFX a través de una conexión de escritorio remoto.
                  </p>
                  <p>
                      primer paso
                  </p>
                  <p>
                      Abra la APLICACIÓN WikiFX, vaya a [Mi]-[Mi VPS] para obtener la IP de su host, su nombre de usuario y su contraseña.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      Paso 2
                  </p>
                  <p>
                      Abra la computadora con Windows, presione y mantenga presionadas las teclas [Win+R], inicie la herramienta de línea de comando e ingrese [mstsc] para conectarse al escritorio remoto.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Ingrese la conexión de escritorio remoto, ingrese la IP del VPS (IP del host) en la columna de la computadora y haga clic en el botón [Conectar]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      Después de que la conexión sea exitosa, ingrese el nombre de la cuenta de inicio de sesión y la contraseña y haga clic en el botón [Aceptar].
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      Aparecerá una ventana emergente, haga clic en [Sí] para continuar con la conexión.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      tercer paso
                  </p>
                  <p>
                      La conexión es exitosa y ingresas al VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        hi: `
        <div class="title-box">विंडोज़ में वीपीएस से कैसे जुड़ें?</div>
                  <p class="bold">
                      वीपीएस क्या है?
                  </p>
                  <p>
                      वीपीएस (वर्चुअल प्राइवेट सर्वर), आप रिमोट डेस्कटॉप कनेक्शन के माध्यम से विकीएफएक्स के वीपीएस तक पहुंच सकते हैं।
                  </p>
                  <p>
                      पहला कदम
                  </p>
                  <p>
                      WikiFX ऐप खोलें, अपना होस्ट आईपी, उपयोगकर्ता नाम और पासवर्ड प्राप्त करने के लिए [My]-[My VPS] पर जाएं।
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      चरण दो
                  </p>
                  <p>
                      विंडोज़ कंप्यूटर खोलें, [विन+आर] कुंजी दबाकर रखें, कमांड लाइन टूल प्रारंभ करें, और दूरस्थ डेस्कटॉप से कनेक्ट करने के लिए [एमएसटीएससी] दर्ज करें।
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      दूरस्थ डेस्कटॉप कनेक्शन दर्ज करें, कंप्यूटर कॉलम में वीपीएस आईपी (होस्ट आईपी) दर्ज करें, और [कनेक्ट] बटन पर क्लिक करें
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      कनेक्शन सफल होने के बाद, लॉगिन खाता नाम और पासवर्ड दर्ज करें, और [ओके] बटन पर क्लिक करें
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      एक पॉप-अप विंडो दिखाई देगी, कनेक्ट करना जारी रखने के लिए [हां] पर क्लिक करें।
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      तीसरा चरण
                  </p>
                  <p>
                      कनेक्शन सफल है और आप वीपीएस में प्रवेश करते हैं।
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        fil: `
        <div class="title-box">Paano kumonekta sa VPS sa Windows?</div>
                  <p class="bold">
                      Ano ang VPS?
                  </p>
                  <p>
                      VPS (Virtual Private Server), maaari mong ma-access ang VPS ng WikiFX sa pamamagitan ng isang remote na koneksyon sa desktop.
                  </p>
                  <p>
                      unang hakbang
                  </p>
                  <p>
                      Buksan ang WikiFX APP, pumunta sa [My]-[My VPS] para makuha ang iyong host IP, username at password.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      Hakbang 2
                  </p>
                  <p>
                      Buksan ang Windows computer, pindutin nang matagal ang [Win+R] key, simulan ang command line tool, at ipasok ang [mstsc] para kumonekta sa remote desktop.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Ipasok ang remote na koneksyon sa desktop, ipasok ang VPS IP (host IP) sa column ng computer, at i-click ang [Connect] button
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      Matapos ang koneksyon ay matagumpay, ipasok ang login account name at password, at i-click ang [OK] na buton
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      May lalabas na pop-up window, i-click ang [Yes] para magpatuloy sa pagkonekta.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      ikatlong hakbang
                  </p>
                  <p>
                      Ang koneksyon ay matagumpay at pumasok ka sa VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        fr: `
        <div class="title-box">Comment se connecter à un VPS sous Windows ?</div>
                  <p class="bold">
                      Qu&#39;est-ce qu&#39;un VPS ?
                  </p>
                  <p>
                      VPS (Virtual Private Server), vous pouvez accéder au VPS de WikiFX via une connexion de bureau à distance.
                  </p>
                  <p>
                      premier pas
                  </p>
                  <p>
                      Ouvrez l&#39;application WikiFX, accédez à [Mon]-[Mon VPS] pour obtenir votre adresse IP hôte, votre nom d&#39;utilisateur et votre mot de passe.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      Étape 2
                  </p>
                  <p>
                      Ouvrez l&#39;ordinateur Windows, maintenez enfoncées les touches [Win+R], démarrez l&#39;outil de ligne de commande et entrez [mstsc] pour vous connecter au bureau distant.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Entrez la connexion au bureau à distance, entrez l&#39;IP VPS (IP hôte) dans la colonne ordinateur et cliquez sur le bouton [Connecter]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      Une fois la connexion réussie, entrez le nom du compte de connexion et le mot de passe, puis cliquez sur le bouton [OK]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      Une fenêtre contextuelle apparaîtra, cliquez sur [Oui] pour continuer la connexion.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      troisième étape
                  </p>
                  <p>
                      La connexion est réussie et vous entrez dans le VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        de: `
        <div class="title-box">Wie verbinde ich mich mit VPS unter Windows?</div>
                  <p class="bold">
                      Was ist ein VPS?
                  </p>
                  <p>
                      VPS (Virtual Private Server): Sie können über eine Remotedesktopverbindung auf den VPS von WikiFX zugreifen.
                  </p>
                  <p>
                      erster Schritt
                  </p>
                  <p>
                      Öffnen Sie die WikiFX-App, gehen Sie zu [Mein] – [Mein VPS], um Ihre Host-IP, Ihren Benutzernamen und Ihr Passwort zu erhalten.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      Schritt 2
                  </p>
                  <p>
                      Öffnen Sie den Windows-Computer, halten Sie die Tasten [Win+R] gedrückt, starten Sie das Befehlszeilentool und geben Sie [mstsc] ein, um eine Verbindung zum Remotedesktop herzustellen.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Geben Sie die Remote-Desktop-Verbindung ein, geben Sie die VPS-IP (Host-IP) in die Computerspalte ein und klicken Sie auf die Schaltfläche [Verbinden].
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      Nachdem die Verbindung erfolgreich hergestellt wurde, geben Sie den Namen und das Passwort des Anmeldekontos ein und klicken Sie auf die Schaltfläche [OK].
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      Es erscheint ein Popup-Fenster. Klicken Sie auf [Ja], um die Verbindung fortzusetzen.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      dritter Schritt
                  </p>
                  <p>
                      Die Verbindung ist erfolgreich und Sie betreten den VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        pt: `
        <div class="title-box">Como se conectar ao VPS no Windows?</div>
                  <p class="bold">
                      O que é um VPS?
                  </p>
                  <p>
                      VPS (Virtual Private Server), você pode acessar o VPS do WikiFX através de uma conexão de área de trabalho remota.
                  </p>
                  <p>
                      Primeiro passo
                  </p>
                  <p>
                      Abra o APP WikiFX, vá para [Meu]-[Meu VPS] para obter seu IP de host, nome de usuário e senha.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      Passo 2
                  </p>
                  <p>
                      Abra o computador Windows, pressione e segure as teclas [Win+R], inicie a ferramenta de linha de comando e digite [mstsc] para conectar-se à área de trabalho remota.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Insira a conexão de área de trabalho remota, insira o IP do VPS (IP do host) na coluna do computador e clique no botão [Conectar]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      Depois que a conexão for bem-sucedida, insira o nome da conta de login e a senha e clique no botão [OK]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      Uma janela pop-up aparecerá, clique em [Sim] para continuar a conexão.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      terceiro passo
                  </p>
                  <p>
                      A conexão foi bem-sucedida e você entra no VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        tr: `
        <div class="title-box">Windows'ta VPS'ye nasıl bağlanılır?</div>
                  <p class="bold">
                      VPS nedir?
                  </p>
                  <p>
                      VPS (Sanal Özel Sunucu), WikiFX&#39;in VPS&#39;sine uzak masaüstü bağlantısı üzerinden erişebilirsiniz.
                  </p>
                  <p>
                      ilk adım
                  </p>
                  <p>
                      WikiFX APP&#39;yi açın, ana bilgisayar IP&#39;nizi, kullanıcı adınızı ve şifrenizi almak için [Benim]-[VPS&#39;im]&#39;e gidin.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      Adım 2
                  </p>
                  <p>
                      Windows bilgisayarını açın, [Win+R] tuşlarını basılı tutun, komut satırı aracını başlatın ve uzak masaüstüne bağlanmak için [mstsc] girin.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      Uzak masaüstü bağlantısını girin, bilgisayar sütununa VPS IP&#39;sini (ana bilgisayar IP&#39;si) girin ve [Bağlan] düğmesine tıklayın
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      Bağlantı başarılı olduktan sonra oturum açma hesabı adını ve parolasını girin ve [OK] düğmesine tıklayın
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      Bir açılır pencere görünecektir; bağlanmaya devam etmek için [Evet]&#39;e tıklayın.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      üçüncü adım
                  </p>
                  <p>
                      Bağlantı başarılı ve VPS&#39;ye giriyorsunuz.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        ko: `
        <div class="title-box">Windows에서 VPS에 연결하는 방법은 무엇입니까?</div>
                  <p class="bold">
                      VPS란 무엇입니까?
                  </p>
                  <p>
                      VPS(Virtual Private Server)를 사용하면 원격 데스크톱 연결을 통해 WikiFX의 VPS에 액세스할 수 있습니다.
                  </p>
                  <p>
                      첫 번째 단계
                  </p>
                  <p>
                      WikiFX 앱을 열고 [내]-[내 VPS]로 이동하여 호스트 IP, 사용자 이름 및 비밀번호를 받으세요.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      2 단계
                  </p>
                  <p>
                      Windows 컴퓨터를 열고 [Win+R] 키를 길게 누른 후 명령줄 도구를 시작한 후 [mstsc]를 입력하여 원격 데스크톱에 연결합니다.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      원격 데스크톱 연결을 입력하고, 컴퓨터 항목에 VPS IP(호스트 IP)를 입력한 후 [연결] 버튼을 클릭하세요.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      연결 성공 후 로그인 계정명과 비밀번호를 입력하고 [확인] 버튼을 클릭하세요.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      팝업창이 나타나면 [예]를 클릭하여 연결을 계속 진행하세요.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      세 번째 단계
                  </p>
                  <p>
                      연결이 성공하고 VPS로 들어갑니다.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`,
        ar: `
        <div class="title-box">كيفية الاتصال بـ VPS في نظام التشغيل Windows؟</div>
                  <p class="bold">
                      ما هو الخادم الافتراضي الخاص؟
                  </p>
                  <p>
                      VPS (الخادم الافتراضي الخاص)، يمكنك الوصول إلى VPS الخاص بـ WikiFX من خلال اتصال سطح المكتب البعيد.
                  </p>
                  <p>
                      الخطوة الأولى
                  </p>
                  <p>
                      افتح تطبيق WikiFX، وانتقل إلى [My] - [My VPS] للحصول على عنوان IP للمضيف واسم المستخدم وكلمة المرور.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon1.png')}"/>
                  </p>
                  <p>
                      الخطوة 2
                  </p>
                  <p>
                      افتح جهاز الكمبيوتر الذي يعمل بنظام Windows، واضغط مع الاستمرار على المفاتيح [Win+R]، وابدأ تشغيل أداة سطر الأوامر، وأدخل [mstsc] للاتصال بسطح المكتب البعيد.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon2.png')}"/>
                  </p>
                  <p>
                      أدخل اتصال سطح المكتب البعيد، وأدخل VPS IP (IP المضيف) في عمود الكمبيوتر، وانقر فوق الزر [Connect]
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon3.png')}"/>
                  </p>
                  <p>
                      بعد نجاح الاتصال، أدخل اسم حساب تسجيل الدخول وكلمة المرور، ثم انقر فوق الزر [موافق].
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon4.png')}"/>
                  </p>
                  <p>
                      ستظهر نافذة منبثقة، انقر فوق [نعم] لمواصلة الاتصال.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon5.png')}"/>
                  </p>
                  <p>
                      خطوة ثالثة
                  </p>
                  <p>
                      كان الاتصال ناجحًا وقمت بإدخال VPS.
                  </p>
                  <p class="m30">
                      <img src="${require('~/assets/img/help/win-icon6.png')}"/>
                  </p>`
      }
    }
  },
  head () {
    return {
      title: this.$t('22975'),
      meta: [
        { name: 'Description', content: this.$t('22976') }
      ]
    }
  }
}
